export default __webpack_public_path__ + "static/media/iconchevronright.4db0223c.svg";